<template>
    <div>
        <div class="d-flex align-center mb-3 ga-2 px-2">
            <v-icon
                :icon="mdiAlphaPBoxOutline"
                size="18"
                style="color: var(--sidebar-text-muted, #6b7280)"
            ></v-icon>
            <h3
                class="text-sm font-semibold uppercase tracking-wider"
                style="color: var(--foreground); font-size: 11px"
            >
                Select Project
            </h3>
        </div>
        <div v-for="(group, index) in project_list" :key="index" class="mb-8">
            <h3
                class="px-3 mb-3 text-xs font-semibold uppercase tracking-wider"
                style="color: var(--card-foreground); font-size: 10px"
            >
                {{ index }}
            </h3>
            <div class="space-y-1">
                <span
                    class="text-sm font-medium text-gray-700 px-3"
                    v-if="project_list.length === 0"
                >
                    No Project Found.
                </span>
                <div v-else>
                    <div class="ml-4 space-y-1">
                        <template v-for="project in group" :key="project.id">
                            <span
                                @click="selectProject(project)"
                                class="project-select-item block text-sm rounded-md transition-colors duration-150 relative cursor-pointer"
                                :class="{
                                    'project-select-active':
                                        project.id === selected_project,
                                }"
                            >
                                {{ project.name }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mdiAlphaPBoxOutline } from "@mdi/js";
export default {
    props: {
        data: {
            type: Object,
        },
        selected_project: {
            type: String,
        },
    },
    data() {
        return {
            project_list: [],
            mdiAlphaPBoxOutline,
        };
    },
    async created() {
        this.project_list = await this.data;
    },
    methods: {
        selectProject(project) {
            this.$emit("select-project", project);
        },
    },
};
</script>

<style scoped>
.project-select-item {
    display: block;
    padding: 0.3125rem 0.625rem;
    font-size: 13px;
    color: var(--card-foreground);
    border-radius: 5px;
    transition: background 0.12s, color 0.12s;
    margin-bottom: 2px;
}

.project-select-item:hover {
    background-color: var(--secondary);
    color: var(--foreground);
}

.project-select-active {
    color: var(--foreground);
    font-weight: 500;
    background-color: var(--secondary);
}
</style>
